// src/pages/Home.jsx
import { useState, useEffect } from "react";
import axios from "axios";
import { useThemeColors } from "../context/ThemeColorContext";
import { useLanguage } from "../context/LanguageContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BannerSlider from "../components/BannerSlider";
import ContactSection from "../components/ContactSection";
import ProjectList from "../components/ProjectList";

const Home = () => {
  const [site, setSite] = useState(null);
  const { darkMode } = useThemeColors();
  const { lang } = useLanguage();
  const { darkPrimary, lightPrimary, lightText } = useThemeColors();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/site-setting/`)
      .then((res) => setSite(res.data))
      .catch((err) => console.error(err));
  }, []);

  if (!site) return <div className="text-center p-6">در حال بارگذاری...</div>;

  return (
    <div
      className="min-h-screen transition-all"
      style={{
        backgroundColor: darkMode ? darkPrimary : lightPrimary,
        color: darkMode ? "#fff" : lightText,
        direction: lang === "fa" ? "rtl" : "ltr",
      }}
    >
      <Header />
      <BannerSlider />
      <ProjectList />
      <ContactSection
        phone={site.phone_number}
        email={site.email}
        address={site.address}
      />
      <Footer />
    </div>
  );
};

export default Home;
